export default {
  platform: {
    freelancer_data: [
      { platform_key: 'zalo_1', platform_name: 'Zalo 1' },
      { platform_key: 'fb', platform_name: 'Facebook' },
      { platform_key: 'fb_rv_1', platform_name: 'FB RV 1' }
    ],
    default_data: [
        { platform_key: 'zalo_1', platform_name: 'Zalo 1' },
        { platform_key: 'zalo_2', platform_name: 'Zalo 2' },
        { platform_key: 'fb', platform_name: 'Facebook' },
        { platform_key: 'fb_tuan_golden', platform_name: 'FB Tuấn Golden' },
        { platform_key: 'fb_rv_1', platform_name: 'FB RV 1' },
        { platform_key: 'fb_rv_2', platform_name: 'FB RV 2' },
        { platform_key: 'web_rv_1', platform_name: 'Web RV 1' },
        { platform_key: 'web_rv_2', platform_name: 'Web RV 2' },
        { platform_key: 'web_agnd', platform_name: 'Web AGND' },
        { platform_key: 'fb_agnd', platform_name: 'FB AGND' },
        { platform_key: 'fb_ads', platform_name: 'FB Ads' },
        { platform_key: 'gg_ads', platform_name: 'Gg Ads' },
        { platform_key: 'ctv', platform_name: 'CTV' }
    ]
  },

  /*
    We'll convert the list of platforms into a string.

    tmp will have the following key and name defined in the ProductPostingTemplate.platform.default_data
        { platform_key: 'zalo_1', platform_name: 'Zalo 1' },
        { platform_key: 'zalo_2', platform_name: 'Zalo 2' },
        { platform_key: 'fb', platform_name: 'Facebook' },
        { platform_key: 'fb_tuan_golden', platform_name: 'FB Tuấn Golden' },
        { platform_key: 'fb_rv_1', platform_name: 'FB RV 1' },
        { platform_key: 'fb_rv_2', platform_name: 'FB RV 2' },
        { platform_key: 'web_rv_1', platform_name: 'Web RV 1' },
        { platform_key: 'web_rv_2', platform_name: 'Web RV 2' },
        { platform_key: 'web_agnd', platform_name: 'Web AGND' },
        { platform_key: 'fb_agnd', platform_name: 'FB AGND' },
        { platform_key: 'fb_ads', platform_name: 'FB Ads' },
        { platform_key: 'gg_ads', platform_name: 'Gg Ads' },
        { platform_key: 'ctv', platform_name: 'CTV' }

    we need to create a platform_names value, if the tmp[platform_key] equal 1, we'll concat the platform_name into the platform_names value
    */

  generatePlatformNames: function(tmp, platformData) {
    let platformNames = '';
  
    platformData.forEach(platform => {
      if (tmp[platform.platform_key] === 1) {
        if (platformNames) {
          platformNames += ', ';
        }
        platformNames += platform.platform_name;
      }
    });
  
    return platformNames;
  },

  template: {
  freelancer_data: [
    {
      id: 1,
      text: 'Mẫu 1: Đất nền',
      value: `
BÁN NỀN ĐƯỜNG LÝ CÔNG UẨN-BÌNH KHÁNH
Diện tích đất : #areaWidth# x #areaLength# = #area# m2, Hướng : #direction#
Vị trí : Đường Lý Công Uẩn
Kết cấu : Đất trống không dính cống và trụ điện.
Miếng đất này nằm trong khu dân cư, cơ sở hạ tầng hoàn thiện, dân cư đông đúc và an ninh, thích hợp đầu tư, xây nhà để ở, cho thuê...
Giá bán :  #price#,000,000đ (giá còn thương lượng)
Liên hệ ngay với Kim - 0916.648.638 (Zalo: Kim Phan-Facebook: Kim Catt) - để xem vị trí và trao đổi thêm nhé !
#kimphan #lyconguan #binhkhanh
`
    },
    {
      id: 2,
      text: 'Mẫu 2: Nhà ở',
      value: `
BÁN NHÀ CẤP 4-ĐƯỜNG HỒ HẢO HỚN-MỸ PHƯỚC
Diện tích đất : #areaWidth# x #areaLength# = #area# m2, Dt nhà: #area#m2, đã hợp thức hóa nhà, Hướng : #direction#
Vị trí : Đường Hồ Hảo Hớn
Kết cấu : Nhà cấp 4, phía sau có đường nội bộ lớn, có công viên
Ngôi nhà nằm trong khu dân cư, gần Bệnh viện, gần Trường học , thích hợp đầu tư, để ở, cho thuê...
Giá bán : #price#,000,000đ (giá còn thương lượng)
Liên hệ ngay với Kim - 0916.648.638 (Zalo: Kim Phan-Facebook: Kim Catt) - để xem vị trí và trao đổi thêm nhé !
#kimphan #myphuoc
`
    },
    {
      id: 3,
      text: 'Mẫu 3: Dự án',
      value: `
BÁN NỀN XẺO TRÔM 3-MỸ PHƯỚC
Vị trí: Đường Số 7- Lô L8-Nền số 34
Diện tích: #areaWidth# x #areaLength# = #area#m2
Hình thức thanh toán: thanh toán 50%+chênh lệch, ký hợp đồng công chứng
Giá bán: #price#,000,000đ
Xẻo trôm 3 chuẩn bị ra giấy, tiềm năng tăng giá vẫn còn, hãy nhanh tay nhé khách !
Anh chị quan tâm Liên hệ ngay với Kim - 0916.648.638 (Zalo: Kim Phan-Facebook: Kim Catt) - để xem vị trí và trao đổi thêm nhé !
#kimphan #xeotrom3 #myphuoc
`
    }
  ],
    default_data: [
        {
          id: 3,
          text: 'Mẫu 1 - Đất dự án',
          value: `
CẦN BÁN NHANH NỀN F9 SỐ 09 - GOLDEN CITY AN GIANG

* Diện tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#
* Vị trí: Nền F9 số 09, sau lưng chi cục thuế, sát khu TTTM Vịnh Trà, Lotte, gần kề đường lớn Nguyễn Hoàng, Nguyễn Thái Học, Hà Hoàng Hổ 
* Trục đường 16m, gần siêu thị Lotte, công viên cây xanh. 
* Thuận lợi để sinh sống hoặc đầu tư / cho thuê quán cafe, quán ăn, xây kho, xây văn phòng cho thuê... 
* Giá bán: #price#,000,000đ (TLN)
* Liên hệ: Tuấn Golden - 0907546852 0931794511 để xem vị trí và trao đổi chi tiết 
>> Xem thêm SP khác tại: angiangnhadat.com  hoặc www.facebook.com/angiangnhadat.ag`
        },
        {
          id: 4,
          text: 'Mẫu 2 - Đất trống',
          value: `
BÁN NHANH 1 NỀN ĐƯỜNG THỤC PHÁN BK3

* Diện tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#
* Vị trí: Nền nằm trên đường chính Thục Phán, qua ngã 4 Thục Phán - Ỷ Lan
* Mặt tiền công viên thoáng mát, vỉa hè rộng 6m. Khu dân cư sinh sống đông đúc yên tĩnh, hàng xóm thân thiện. Đường Thục Phán đang triển khai nâng cấp đường cao ráo, làm lại công viên, giá trị đang tăng lên theo thời gian
* Thuận lợi để sinh sống hoặc đầu tư, xây văn phòng cho thuê...
* Giá bán: #price#,000,000đ (thương lượng)
* Liên hệ: Tuấn Golden - 0907546852 0931794511  để xem vị trí và trao đổi chi tiết
>> Xem thêm SP khác tại: angiangnhadat.com  hoặc www.facebook.com/angiangnhadat.ag`
        },
        {
          id: 5,
          text: 'Mẫu 3 - Nhà cấp 4',
          value: `
BÁN NHÀ CẤP 4 ĐƯỜNG PHAN KẾ BÍNH, BÌNH KHÁNH

* Diện tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#
* Vị trí: Mặt tiền đường Phan Kế Bính, đường oto 5m, sử dụng thêm 2m vỉa hè. Từ Hàm Nghi quẹo vào 200m.
* Nhà mới sửa chữa sạch đẹp, rộng rãi với 2 phòng ngủ, gần công viên thoáng mát yên tĩnh. Gần chợ Bình Khánh, trường học, siêu thị.., Thuận tiện ra các trục đường chính Thành Thái, Hàm Nghi... 
* Thích hợp để cho gia đình nhỏ ra riêng, gia đình chuộng công viên, mua đầu tư,...
* Giá bán: #price#,000,000đ (thương lượng) 
* Liên hệ: Tuấn Golden - 0907546852 0931794511  để xem vị trí và trao đổi chi tiết
>> Xem thêm SP khác tại: angiangnhadat.com  hoặc www.facebook.com/angiangnhadat.ag`
        },
        {
          id: 6,
          text: 'Mẫu 4 - Nhà mới xây',
          value: `
BÁN NHÀ CẤP 4 ĐƯỜNG PHAN KẾ BÍNH, BÌNH KHÁNH

* Diện tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#
* Vị trí: Mặt tiền đường Phan Kế Bính, đường oto 5m, sử dụng thêm 2m vỉa hè. Từ Hàm Nghi quẹo vào 200m.
* Nhà mới sửa chữa sạch đẹp, rộng rãi với 2 phòng ngủ, gần công viên thoáng mát yên tĩnh. Gần chợ Bình Khánh, trường học, siêu thị.., Thuận tiện ra các trục đường chính Thành Thái, Hàm Nghi... 
* Thích hợp để cho gia đình nhỏ ra riêng, gia đình chuộng công viên, mua đầu tư,...
* Giá bán: #price#,000,000 đ (thương lượng) 
* Liên hệ: Tuấn Golden - 0907546852 0931794511  để xem vị trí và trao đổi chi tiết
>> Xem thêm SP khác tại: angiangnhadat.com  hoặc www.facebook.com/angiangnhadat.ag`
        },
        {
          id: 7,
          text: 'Mẫu 5 - Chung cư',
          value: `
BÁN CĂN HỘ CHUNG CƯ MARINA 1 PHÒNG NGỦ - LOẠI C1

* Vị trí: Chung cư Marina, P Mỹ Bình, Loại Căn hộ C1, tầng 3B (Toà nhà 23 tầng). 
* Diện tích: #area#m2 Hướng cửa: #direction# có view nhìn ra đường Lê Văn Nhung và bờ sông Long Xuyên thoáng mát.
* Thiết kế: 1 phòng khách, 1 phòng ngủ, 1 toilet, 1 bếp, 1 logia 
* Tiện ích: Vincom, Nguyễn Kim, Cafe Marina, rạp chiếu phim, nhà hàng, siêu thị, chợ, công viên, trường học, bệnh viện,..
* Tiến độ thanh toán hiện tại: 60% giá trị căn hộ. Thời gian bàn giao: Tháng 11/2020.
* Giá bán: #price#,000,000đ (thương lượng)
* Liên hệ: Tuấn Golden - 0907546852 0931794511  để xem vị trí và trao đổi chi tiết 
>> Xem thêm SP khác tại: angiangnhadat.com  hoặc www.facebook.com/angiangnhadat.ag`
        },
        {
          id: 8,
          text: 'Mẫu cho CTV',
          value: `
    BÁN NHÀ CẤP 4 ĐƯỜNG PHAN KẾ BÍNH, BÌNH KHÁNH
    
    * Vị trí: Mặt tiền đường Phan Kế Bính, đường oto 5m, sử dụng thêm 2m vỉa hè. Từ Hàm Nghi quẹo vào 200m.
    * Diện tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#
    * Nhà mới sửa chữa sạch đẹp, rộng rãi với 2 phòng ngủ, gần công viên thoáng mát yên tĩnh. Gần chợ Bình Khánh, trường học, siêu thị.., Thuận tiện ra các trục đường chính Thành Thái, Hàm Nghi... 
    * Thích hợp để cho gia đình nhỏ ra riêng, gia đình chuộng công viên, mua đầu tư,...
    * Giá bán: #price#,000,000đ (thương lượng) 
    * Điện thoại: 
    `
        },
        {
          id: 9,
          text: 'Mẫu Đăng tin nhanh',
          value: `
Bán nền nhà #structure# #street#, #ward#
* Diện tích: #areaWidth# x #areaLength# = #area# m2 #usageType#; Hướng: #direction#
* Giá chính chủ: #price#,000,000đ (TLN)
* MSP: #code#
* LH: Tuấn Golden - 0907546852 0931794511 để trao đổi chi tiết
`
        },
        {
          id: 10,
          text: 'Mẫu bán đất',
          value: `
🔰 Bán Nền Đẹp Đường #street#, #ward#
          
📐 Diện Tích: #areaWidth# x #areaLength# = #area# m2 (#usageType#); Hướng: #direction# 
📍 Mặt tiền đường Bùi Văn Danh, từ Quán Hiếu Báu vào 50m, Hẻm betong 3m 
🏠 Nền đẹp thoáng mát; Phù hợp cho Gia Đình trẻ mua đất xây nhà, mua đầu tư,... 
💰 Giá Chính Chủ: #price# triệu (TL) 
🆔 MSP: #code# 
☎️ LH: Tuấn Golden - 0907546852 Nguyên - 0901241224 để trao đổi chi tiết. 
🌐 Xem thêm SP khác tại: https://nguyenphatland.com/ hoặc https://www.facebook.com/nguyenphatlandag
`
        },
        {
          id: 11,
          text: 'Mẫu bán nhà',
          value: `
🏠 Bán Nhà Mới Đẹp Đường #street#, #ward#
📐 Diện Tích: #areaWidth# x #areaLength# = #area# m2 (#usageType#); Nhà #structure#
🏡 Nhà Mới Đẹp, Vào Ở Ngay; Gồm 3 Phòng Ngủ, 2 WC, Phòng Khách, Bếp. 
📌 Khu Dân Cư An Ninh, Lộ Ô Tô 4m, Gần Chợ và Trung Tâm Thành Phố. 
🎁 Tặng Kèm: 2 Máy Lạnh, Sofa, Máy Năng Lượng. 
📕 Giấy Tờ Đầy Đủ, đang làm hợp thức hóa nhà 
👨‍👩‍👧‍👦 Phù hợp gia đình trẻ ra riêng, mua cho thuê... 
💰 Giá Chính Chủ: #price# triệu (TL) 
🆔 MSP: #code#
☎️ LH: Tuấn Golden - 0907546852 Nguyên - 0901241224 để trao đổi chi tiết. 
🌐 Xem thêm SP khác tại: https://nguyenphatland.com/ hoặc https://www.facebook.com/nguyenphatlandag
`
        },
        {
          id: 12,
          text: 'Mẫu cho thuê đất',
          value: `
🔴 Cho Thuê Nền Đẹp Đường #street#, #ward#
📏 Diện Tích: #areaWidth# x #areaLength# = #area# m2; Hướng: #direction#  
🚩 Nền rộng, mặt tiền đường Nguyễn Thái Học, khu kinh doanh sầm uất 
✅ Phù hợp kinh doanh quán ăn, quán cafe, nhà kho, showroom bán hàng... 
💵 Giá Cho thuê: #priceForRent# triệu/tháng 
🆔 MSP: #code# 
☎️ LH: Tuấn Golden - 0907546852 Nguyên - 0901241224 để trao đổi chi tiết. 
🌐 Xem thêm SP khác tại: https://nguyenphatland.com/bds-cho-thue hoặc https://www.facebook.com/nhathuelongxuyenangiang
`
        },
        {
          id: 13,
          text: 'Mẫu cho thuê nhà',
          value: `
📣 Cho Thuê Nhà Mới Đẹp Đường #street#, #ward#
📏 Diện Tích: #areaWidth# x #areaLength# = #area# m2; Nhà #structure#; Hướng: #direction#  
🏠 Nhà Mới Đẹp, Vào Ở Ngay; Gồm 3 Phòng Ngủ, 2 WC, Phòng Khách, Bếp. 
🚩 Khu Dân Cư An Ninh, Lộ Ô Tô 4m, Gần Chợ và Trung Tâm Thành Phố, nhiều tiện ích xung quanh 
🎁 Nội thất có sẵn: 2 Máy Lạnh, Sofa, Máy Năng Lượng. 
✅ Phù hợp gia đình trẻ thuê ở, làm văn phòng, trụ sở kinh doanh, quán cafe... 
💵 Giá Cho thuê: #priceForRent# triệu/tháng 
🆔 MSP: #code#
☎️ LH: Tuấn Golden - 0907546852 Nguyên - 0901241224 để trao đổi chi tiết. 
🌐 Xem thêm SP khác tại: https://nguyenphatland.com/bds-cho-thue hoặc https://www.facebook.com/nhathuelongxuyenangiang
`
        },
      ]
    },

  
 }